import type { Prototype } from "../prototype-types";

// Prototypes for Jeremy Leclerc.
export const jeremyLeclercPrototypes: Prototype[] = [
  {
    id: "faire-source-cart-organization",
    name: "Faire Source Cart Organization",
    path: "/jl/faire-source-cart-organization",
    description:
      "Visual hierarchy explorations across all three cart surfaces — multi-brand Faire Source, Faire Source brand cart (Jade's Hats), and a non-Faire Source brand cart (Panda's Chocolates). Switch between them via the left rail.",
    project: "Faire Source Cart",
    owner: "Jeremy",
    createdAt: "2026-04-15",
    lastUpdated: "2026-04-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/83e2b2fdea15ab2e37d934147ab9d3518c6b26af64b3a0e15b5d3422e23caccd.png",
    creationTool: "cursor",
  },
  {
    id: "faire-source-cart-keep-shopping-cta",
    name: "Faire Source Cart keep shopping CTA",
    path: "/jl/faire-source-cart-keep-shopping-cta",
    description:
      "Baseline below-minimum Faire Source cart state for exploring a keep-shopping CTA near the disabled checkout action.",
    project: "Faire Source Cart",
    owner: "Jeremy",
    createdAt: "2026-04-28",
    lastUpdated: "2026-04-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4fcb40e05c2b4112f312edc12d9c274f66e1a730a2abff377de7bf35045b0b15.png",
  },
  {
    id: "jl-faire-source-brand-cart-little-sister-nudge",
    name: "Faire Source Brand Cart Little Sister Nudge",
    path: "/jl/faire-source-brand-cart-little-sister-nudge",
    description:
      "Exploring a 'little sister' nudge in the Faire Source brand cart (Jade's Hats) to encourage adding from another Faire Source brand.",
    project: "Faire Source Cart",
    owner: "Jeremy",
    createdAt: "2026-05-06",
    lastUpdated: "2026-05-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/bb78f5fb1c4c1b1c0eb3d0ed2c126c765b5df948149e9d1c322e789e83e75e34.png",
    creationTool: "claude-code",
  },
  {
    id: "jl-faire-source-abandoned-cart-nudge",
    name: "Faire Source Abandoned Cart Nudge",
    path: "/jl/faire-source-abandoned-cart-nudge",
    description:
      "Adds a Faire Source variant to the abandoned cart nudge side panel — mirrors the existing brand-cart nudge styling, with copy cues from the Faire Source card on the Carts page.",
    project: "Faire Source Cart",
    owner: "Jeremy",
    createdAt: "2026-05-07",
    lastUpdated: "2026-05-07",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f25f5453672b1acaf0ac2c610677bbb26588eaddabdab1d0bb3c425e45a773c0.png",
    creationTool: "cursor",
  },
  {
    id: "jl-faire-source-cart-info-banner",
    name: "Faire Source Cart Info Banner",
    path: "/jl/faire-source-cart-info-banner",
    description:
      "First-time Faire Source cart banner explaining what Faire Source is, for retailers who reach the cart before visiting the shop",
    owner: "Jeremy Leclerc",
    createdAt: "2026-06-17",
    lastUpdated: "2026-06-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.faire.com/fastly/225b05bd390517186f4de010dfe756fed2f4c0f47f211c7fb12c6d880a0a3609.png",
    creationTool: "claude-code",
  },
];
